export default {
    '1a-diagram4': {
        'diagram-task': 'Arrange the points to fit the pyramid structure, then press Complete to see your answer',
        'element_4_11': 'Increases chances of destructive conflict',
        'element_4_1': 'Teams larger than 4-6 people do not work productively together',
        'element_4_5': 'More people to organize',
        'element_4_6': 'More handovers to explain',
        'element_4_2': 'They have less time available to do the work',
        'element_4_7': 'More opportunities for miscommunication',
        'element_4_8': 'More likelihood of mistakes',
        'element_4_3': 'They do it less efficiently',
        'element_4_9': 'Can’t pay personal attention to each member',
        'element_4_10': 'Weakens the team’s social glue',
        'element_4_4': 'They take less pleasure in doing it',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1a/diagram4/i18n/en.js